import { render, staticRenderFns } from "./CouponDetails.vue?vue&type=template&id=03f0d20d&scoped=true&"
import script from "./CouponDetails.vue?vue&type=script&lang=js&"
export * from "./CouponDetails.vue?vue&type=script&lang=js&"
import style0 from "./CouponDetails.vue?vue&type=style&index=0&id=03f0d20d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03f0d20d",
  null
  
)

export default component.exports